/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import {
  Card,
  Typography,
  Button,
  Tag,
  Spin,
  Row,
  Col,
  Modal,
  message,
} from "antd";
import axios from "axios";
import emailAssistant from "../../../Assets/MyProfile/email assistant Icon Final 1.png";
import familyCalendar from "../../../Assets/MyProfile/Family Calendar 1 1.png";
import coParentCalendar from "../../../Assets/MyProfile/Co Parent Calendar Icon 1.png";
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm from "../../Payments/PaymentForm";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@mui/icons-material";

const URL = process.env.REACT_APP_API_URL;
const stripePromise = loadStripe(
  "pk_test_51ROvWiPNhqoxPYwxdrEdMIt5MRvfupMkXlDuWa4DPMtPOHaZG5stLrDr3mBST8fxNKP7CknTgglLDizcKiTJhuMf00MVVOWqAc"
);

const { Title, Paragraph, Text } = Typography;

const Container = styled.div`
  padding: 2rem;
  background: #f5f7fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const CenterButton = styled(Button)`
  margin-top: 3rem;
`;

const PlanCard = styled(Card)`
  position: relative;
  background: #ffffff;
  border: 2px solid
    ${({ isPurchased }) => (isPurchased ? "#52c41a" : "#e5e5e5")};
  border-radius: 16px;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  margin: 5px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    border-color: ${({ isPurchased }) => (isPurchased ? "#52c41a" : "#9a4fe0")};
  }

  .ant-typography {
    font-size: 13px;
  }

  .ant-typography h4 {
    font-size: 16px;
  }

  .ant-tag {
    font-size: 12px;
  }

  button {
    font-size: 13px;
  }
`;

const SubscribeButton = styled(Button)`
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
  border-radius: 8px;
  height: 40px;
  width: 88% !important;
`;

const ContentArea = styled.div`
  flex: 1;
  // overflow-y: auto;
  margin-bottom: 60px; /* leaves space for button */
  padding-right: 4px;

  /* scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d1d1d1;
    border-radius: 3px;
  }
`;

const CornerTag = styled.div`
  position: absolute;
  top: 18px;
  right: -60px; /* adjust for perfect diagonal placement */
  background: ${({ color }) => color || "#52c41a"};
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 19px 60px;
  transform: rotate(45deg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 5;
  pointer-events: none; /* prevent accidental clicks */
`;

const ImageContainer = styled.div`
  text-align: center;
  margin-bottom: 12px;

  img {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 8px;
`;

const Feature = styled.li`
  font-size: 14px;
  color: #555;
  margin-bottom: 6px;
  display: flex;
  align-items: center;

  &::before {
    content: "✓";
    color: #9a4fe0;
    margin-right: 8px;
    font-weight: bold;
  }
`;

const Price = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 8px 0 10px;
`;

const SubscriptionPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [currentStepC2, setCurrentStepC2] = useState(2);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const navigate = useNavigate();

  const fetchSubscriptions = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.get(`${URL}/v1/user/subscription`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      const subs = data.data.subscriptions;
      setSubscriptionData(subs);
      setPlans(data.data.subscriptions || []);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const handleSubscribe = (id) => {
    const plan = subscriptionData.find((p) => p.subscription_id === id);
    if (!plan) {
      message.error("Please select a subscription plan.");
      return;
    }
    if (plan.is_purchased) {
      message.error("You are already subscribed to this plan.");
      return;
    }
    setSelectedPlan(plan);
    setCurrentStepC2(3);
  };
  const getPlanIcon = (title) => {
    if (title.includes("Lifestyle Core")) return emailAssistant;
    if (title.includes("Family")) return familyCalendar;
    if (title.includes("Co-Parent")) return coParentCalendar;
    return null;
  };

  if (loading)
    return <Spin style={{ display: "block", margin: "4rem auto" }} />;

  const handleGoToDashboard = () => {
    window.location.href = "/dashboard"; // prevents back to pricing
  };

  return (
    <>
      {currentStepC2 === 2 && (
        <Container>
          <div className="">
            <Button
              onClick={() => navigate(-1)}
              style={{
                marginBottom: 20,
                position: "absolute",
                top: 20,
                left: 20,
              }}
            >
              <ArrowLeftOutlined /> Back
            </Button>
            <Title
              level={2}
              style={{
                textAlign: "center",
                fontSize: "20px",
                marginTop: "25px",
              }}
            >
              Subscription Options
            </Title>
          </div>

          <Row
            gutter={[16, 16]}
            style={{ maxWidth: "1200px", margin: "0 auto" }}
          >
            {plans.slice(0, 4).map((plan) => {
              const now = new Date();
              const isActive =
                plan.billing_cycle === "yearly" ||
                plan.billing_cycle === "quarterly" ||
                plan.billing_cycle === "daily"
                  ? plan.is_active === 1
                  : plan.is_purchased &&
                    new Date(plan.user_subscription_end_date) >= now;
              return (
                <Col lg={6} md={12} xs={24} key={plan.subscription_id}>
                  <PlanCard isPurchased={isActive}>
                    {isActive && (
                      <CornerTag color="#52c41a">Active Plan</CornerTag>
                    )}

                    <ContentArea>
                      <ImageContainer
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {getPlanIcon(plan.title) ? (
                          <img src={getPlanIcon(plan.title)} alt={plan.title} />
                        ) : (
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              borderRadius: "8px",
                              backgroundColor: "#f0f0f0",
                            }}
                          /> // shows first 2 letters as fallback
                        )}
                      </ImageContainer>

                      <Title
                        level={4}
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          minHeight: "48px",
                        }}
                      >
                        {plan.title}
                      </Title>

                      <Paragraph
                        className="custom-scrollbar"
                        style={{
                          textAlign: "center",
                          color: "#666",
                          maxHeight: "100px",
                          minHeight: "100px",
                          overflowY: "scroll",
                          padding: "5px",
                          // scrollbarWidth: "thin",
                          // msOverflowStyle: "thin",
                        }}
                      >
                        {plan.description}
                      </Paragraph>

                      <Price>
                        {plan?.special_price ? (
                          <>
                            <span className="amount">
                              £{plan.special_price}
                            </span>
                            <span
                              style={{ display: "inline-block", width: 8 }}
                            />
                            <span
                              style={{
                                color: "#ff4d4f",
                                textDecoration: "line-through",
                                marginRight: 8,
                              }}
                            >
                              £{plan.price}
                            </span>
                          </>
                        ) : (
                          <span className="amount">£{plan.price}</span>
                        )}

                        <Text type="secondary" style={{ marginLeft: 4 }}>
                          /
                          {plan.billing_cycle
                            ? plan.billing_cycle.charAt(0).toUpperCase() +
                              plan.billing_cycle.slice(1)
                            : ""}
                        </Text>
                      </Price>

                      {/* {plan.trial_period_in_days > 0 ? (
                        <Tag
                          color="blue"
                          style={{ display: "block", textAlign: "center" }}
                        >
                          {plan.trial_period_in_days}-day Free Trial
                        </Tag>
                      ) : (
                        <div> */}
                      <Tag
                        color="blue"
                        style={{ display: "block", textAlign: "center" }}
                      >
                        No Trial details Available
                      </Tag>
                      {/* </div>
                      )} */}

                      <Paragraph strong style={{ marginTop: 12 }}>
                        {plan.service_header}
                      </Paragraph>

                      <FeaturesList
                        className="custom-scrollbar"
                        style={{
                          maxHeight: "100px",
                          minHeight: "100px",
                          overflowY: "scroll",
                          overflowX: "hidden",
                          // scrollbarWidth: "none",
                          // msOverflowStyle: "none",
                        }}
                      >
                        {plan.services.map((service) => (
                          <Feature key={service.id}>{service.name}</Feature>
                        ))}
                      </FeaturesList>
                    </ContentArea>

                    <SubscribeButton
                      type="primary"
                      block
                      disabled={isActive}
                      onClick={() => handleSubscribe(plan.subscription_id)}
                    >
                      {isActive ? "Subscribed" : "Subscribe"}
                    </SubscribeButton>
                  </PlanCard>
                </Col>
              );
            })}
          </Row>

          {plans.length > 4 && (
            <CenterButton
              type="primary"
              size="large"
              onClick={() => setVisible(true)}
            >
              See All Plans
            </CenterButton>
          )}

          <Modal
            open={visible}
            title={
              <span style={{ fontSize: "18px" }}>
                Available Subscription Plans
              </span>
            }
            onCancel={() => setVisible(false)}
            footer={null}
            width="95%"
            style={{ top: 40 }}
            bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
          >
            <Row
              gutter={[6, 6]}
              style={{ maxWidth: "1200px", margin: "0 auto" }}
            >
              {plans.map((plan) => {
                const now = new Date();
                const isActive =
                  plan.billing_cycle === "yearly" ||
                  plan.billing_cycle === "quarterly" ||
                  plan.billing_cycle === "daily"
                    ? plan.is_active === 1
                    : plan.is_purchased &&
                      new Date(plan.user_subscription_end_date) >= now;
                return (
                  <Col lg={6} md={12} xs={24} key={plan.subscription_id}>
                    <PlanCard isPurchased={isActive}>
                      {isActive && (
                        <CornerTag color="#52c41a">Active Plan</CornerTag>
                      )}

                      <ContentArea>
                        <ImageContainer
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {getPlanIcon(plan.title) ? (
                            <img
                              src={getPlanIcon(plan.title)}
                              alt={plan.title}
                            />
                          ) : (
                            <div
                              style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "8px",
                                backgroundColor: "#f0f0f0",
                              }}
                            /> // shows first 2 letters as fallback
                          )}
                        </ImageContainer>

                        <Title
                          level={4}
                          style={{
                            textAlign: "center",
                            fontSize: "16px",
                            minHeight: "48px",
                          }}
                        >
                          {plan.title}
                        </Title>

                        <Paragraph
                          className="custom-scrollbar"
                          style={{
                            textAlign: "center",
                            color: "#666",
                            maxHeight: "100px",
                            minHeight: "100px",
                            overflowY: "scroll",
                            // scrollbarWidth: "none",
                            // msOverflowStyle: "none",
                          }}
                        >
                          {plan.description}
                        </Paragraph>

                        <Price>
                          £{plan.price}{" "}
                          <Text type="secondary">
                            /
                            {plan.billing_cycle.charAt(0).toUpperCase() +
                              plan.billing_cycle.slice(1)}
                          </Text>
                        </Price>

                        {/* {plan.trial_period_in_days > 0 ? (
                          <Tag
                            color="blue"
                            style={{ display: "block", textAlign: "center" }}
                          >
                            {plan.trial_period_in_days}-day Free Trial
                          </Tag>
                        ) : (
                          <div> */}
                        <Tag
                          color="blue"
                          style={{ display: "block", textAlign: "center" }}
                        >
                          No Trial details Available
                        </Tag>
                        {/* </div>
                        )} */}

                        <Paragraph strong style={{ marginTop: 12 }}>
                          {plan.service_header}
                        </Paragraph>

                        <FeaturesList
                          className="custom-scrollbar"
                          style={{
                            maxHeight: "100px",
                            minHeight: "100px",
                            overflowY: "scroll",
                            overflowX: "hidden",
                            // scrollbarWidth: "none",
                            // msOverflowStyle: "none",
                          }}
                        >
                          {plan.services.map((service) => (
                            <Feature key={service.id}>{service.name}</Feature>
                          ))}
                        </FeaturesList>
                      </ContentArea>

                      <SubscribeButton
                        type="primary"
                        block
                        disabled={isActive}
                        onClick={() => handleSubscribe(plan.subscription_id)}
                      >
                        {isActive ? "Subscribed" : "Subscribe"}
                      </SubscribeButton>
                    </PlanCard>
                  </Col>
                );
              })}
            </Row>
          </Modal>
        </Container>
      )}

      {currentStepC2 === 3 && (
        <Elements stripe={stripePromise}>
          <PaymentForm
            subscriptionData={subscriptionData}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            onBack={() => setCurrentStepC2(2)}
            onSubscribed={async () => {
              // message.success("Subscribed successfully!");
              await fetchSubscriptions();
              setCurrentStepC2(4);
            }}
          />
        </Elements>
      )}

      {currentStepC2 === 4 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
            background: "#f9f9f9",
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: 600,
              marginBottom: "16px",
              color: "#52c41a",
            }}
          >
            🎉 Thank you for subscribing!
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "32px", color: "#333" }}>
            You are now on the <strong>{selectedPlan?.title}</strong> plan.
          </p>
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: "8px", padding: "0 24px" }}
            onClick={handleGoToDashboard}
          >
            Go to Dashboard
          </Button>
        </div>
      )}
    </>
  );
};

export default SubscriptionPlans;
